export interface UserLaneMessageType {
  messageTypeId: string;
  selected: boolean;
  description: string;
}
